<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="ack"><a id="pageix"></a>acknowledgments</h1>
<p class="indent">This book would not be possible without the genius and creativity of chefs both past and present: Martha Hartley, Bill Rosenberg, Dave Curtis, Jose Palacios, Pedro Garzon, Elder Morales, Antonio Saldana, and Victor Sanchez all have invented and perfected the dishes that appear on these pages. Pedro and Adam Halberg have shaped the menus for the company as a whole, and Lisa Varnberg, in addition to creating some Barcelona classics, spent countless hours testing and transcribing recipes that were little more than scribbled notes on crumpled paper when she got them. Gretchen Thomas poured her encyclopedic knowledge of wine onto these pages. Mary Goodbody worked day and night to turn our thoughts into words and even spent time shivering in fish coolers and butchering steaks. Jean Lucas, Kirsty Melville, and Tim Lynch at Andrews McMeel believed in Barcelona and in us enough to see this book through from beginning to end, and Jane Dystel, our inimitable agent, made the whole thing happen. We are deeply indebted to them for handling the hard part so that we could continue making tapas, pouring wine, and serving tables.</p>
<p class="center"><a id="pagex"></a><img alt="" src="OEBPS/images/x-1.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780740790683_epub_ack_r1.vue?dec291d6